"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_apollo_1 = require("react-apollo");
const react_jss_1 = require("react-jss");
const styles_1 = require("@wds/styles");
const getApolloClient_1 = tslib_1.__importDefault(require("./getApolloClient"));
/**
 * Wrapper for shareable components, to be used to set up the context needed to
 * run them as standalone component in consuming apps.
 *
 * Adds WDS theme and necessary ApolloProvider
 */
const ComponentWrapper = ({
  children,
  graphQLClientConfig,
  fragmentTypes
}) => {
  if (graphQLClientConfig) {
    return react_1.default.createElement(react_jss_1.ThemeProvider, {
      theme: styles_1.WrenchTheme
    }, react_1.default.createElement(react_apollo_1.ApolloProvider, {
      client: (0, getApolloClient_1.default)(graphQLClientConfig, fragmentTypes)
    }, children));
  }
  return react_1.default.createElement(react_jss_1.ThemeProvider, {
    theme: styles_1.WrenchTheme
  }, children);
};
exports.default = ComponentWrapper;